import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import { useLocation } from "react-router-dom";
import List from "../Components/TechnicalSupport/List";
import Action from "../Components/TechnicalSupport/Action";
import View from "../Components/TechnicalSupport/View";
function TechnicalSupport() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();

  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Technical Support</h1>
          </div>

          {comp === "list" ? (
            <List comp={comp} onChange={handleChange} rowData={rowData} />
          ) : comp === "view" ? (
            <View comp={comp} onChange={handleChange} rowData={rowData} />
          ) : (
            <Action comp={comp} onChange={handleChange} rowData={rowData} />
          )}
        </section>
      </div>
    </Layout>
  );
}

export default TechnicalSupport;
